import tasksPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  listsSearchContexts: {
    tasksList: null,
  },
  isCreateDialogOpen: false,
  list: [],
};

const reducer = createReducer(INITIAL_STATE, {
  [tasksPageActionTypes.TASKS_PAGE_SET_SEARCH]: (state: any, action: any) => {
    return {
      ...state,
      listsSearchContexts: {
        ...state.listsSearchContexts,
        [action.list]: action.search,
      },
    };
  },
  [tasksPageActionTypes.TASKS_PAGE_TOGGLE_CREATE_DIALOG]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isCreateDialogOpen: action.isOpen,
    };
  },
  [tasksPageActionTypes.TASKS_PAGE_LIST_REPLACE]: (
    state: any,
    action: any,
  ) => ({
    ...state,
    list: [...action.values],
  }),
  [tasksPageActionTypes.TASKS_PAGE_LIST_PUSH]: (state: any, action: any) => ({
    ...state,
    list:
      action.pushLocation === 'top'
        ? [...action.values, ...state.list]
        : [...state.list, ...action.values],
  }),
});

export default reducer;
